import React from 'react';

/**
 * InsightPanel — "ACADEMIC INSIGHT" section inside the HealthDrawer.
 * Renders max 3 short, pattern-based insights (no raw lists).
 *
 * Props:
 *   insights — from useAcademicInsights
 */

const ICON_MAP = {
  brain:    '\uD83E\uDDE0',  // 🧠
  warning:  '\u26A0',        // ⚠
  calendar: '\uD83D\uDCC6',  // 📆
  trendUp:  '\uD83D\uDCC8',  // 📈
  check:    '\u2714',        // ✔
};

export default React.memo(function InsightPanel({ insights = [] }) {
  if (insights.length === 0) return null;

  return (
    <div className="hd-insightCard">
      <h3 className="hd-sectionLabel">Academic Insight</h3>
      <div className="hd-insightRows">
        {insights.map((insight) => (
          <div
            key={insight.id}
            className={`hd-insightRow hd-insightRow--${insight.severity}`}
          >
            <span className="hd-insightAccent" aria-hidden="true" />
            <span className="hd-insightIcon" aria-hidden="true">
              {ICON_MAP[insight.icon] || '\uD83E\uDDE0'}
            </span>
            <span className="hd-insightBody">
              <span className="hd-insightTitle">{insight.title}</span>
              <span className="hd-insightDesc">{insight.description}</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
});
